<template>
  <div class="bloodGlucoseControl">
    <v-text-field
        v-if="!hiLoEnabled"
        v-model="textValue"
        type="number"
        :label="label"
        :maxlength="maxlength"
        hide-details
    >
      <template v-slot:append-outer>
        <v-checkbox
            v-model="hiLoEnabled"
            label="HI/LO"
            class="hiLoCheckbox mt-0"
            hide-details
            dense
        />
      </template>
    </v-text-field>

    <v-select
        v-if="hiLoEnabled"
        v-model="textValue"
        :items="hiLoValues"
        hide-details
    >
      <template v-slot:append-outer>
        <v-checkbox
            v-model="hiLoEnabled"
            label="HI/LO"
            class="hiLoCheckbox mt-0"
            hide-details
            dense
        />
      </template>
    </v-select>
  </div>
</template>
<script>
export default {
  name: 'Joules',
  props: {
    value: {
      type: [String, Number],
    },
    label: {
      type: String,
    },
    field: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiLoValues: ['HI', 'LO'],
    };
  },
  computed: {
    hiLoEnabled: {
      get() {
        return this.value && this.hiLoValues.includes(this.value);
      },
      set(value) {
        if (value) {
          this.textValue = 'HI';
        } else {
          this.textValue = null;
        }
      },
    },
    textValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    maxlength() {
      if (this.field.restrictions && this.field.restrictions.maxlen) {
        return this.field.restrictions.maxlen;
      }
      return 255;
    },
  },
};
</script>
<style lang="scss">
.bloodGlucoseControl {
  .v-input__append-outer {
    margin-top: 5px !important;
  }
  .hiLoCheckbox label {
    top: 0px !important;
  }
}
</style>
